import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import styled from "styled-components";
import { Text } from "src/apps/components/typography/Texts";
import { T } from "../i18n/Translation";
import { useIsMedia } from "src/apps/hooks/useIsMedia";
import { MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";
import { useTheme } from "src/apps/providers/ThemeStore";
import { colors } from "@permisso/permisso-components";

const BANNER_MOBILE = "documentation_area.banner.mobile";
const BANNER_DESKTOP = "documentation_area.banner.desktop";

export const Banner = () => {
  const { isDesktop } = useIsMedia();
  const { companyName } = useTheme();
  const bannerText = isDesktop ? BANNER_DESKTOP : BANNER_MOBILE;

  return (
    <Container>
      <BannerText $color={colors.grey0}>
        <T k={bannerText} params={{ companyName }} />
      </BannerText>
      <Icon size={ICON_SIZES.s12} color={colors.grey0} path={ICON_PATHS.LOCK} />
    </Container>
  );
};

const Container = styled.div`
  height: 1.75rem;
  gap: 0.375rem;
  background-color: ${({ theme }) => theme.primaryColor};
  align-items: center;
  justify-content: center;
  display: flex;
  position: sticky;
  top: 0;
  z-index: 100;
`;

const BannerText = styled(Text)`
  font-weight: bold;
  color: ${colors.grey0};
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    font-weight: 500;
    font-size: 0.875rem;
  }
`;
